import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const HeroBanners = () => {
  const { t } = useLanguage();

  const banners = [
    {
      id: 1,
      title: t.hero.banners.banner1Title,
      description: t.hero.banners.banner1Description,
      bonus: t.hero.banners.banner1Bonus,
      cta: t.hero.banners.banner1Cta,
      href: "https://tally.so/r/jaBxRR",
    },
    {
      id: 2,
      title: t.hero.banners.banner2Title,
      description: t.hero.banners.banner2Description,
      bonus: t.hero.banners.banner2Bonus,
      cta: t.hero.banners.banner2Cta,
      href: "https://tally.so/r/lbNLv6",
    },
  ];

  return (
    <div className="flex flex-col gap-5 mt-10 max-w-2xl">
      {banners.map((b) => (
        <a
          key={b.id}
          href={b.href}
          target="_blank"
          rel="noopener noreferrer"
          className="group block rounded-2xl border border-border bg-card p-7 shadow-sm hover:shadow-lg hover:border-primary/40 transition-all duration-200 cursor-pointer"
        >
          <h3 className="text-lg md:text-xl font-bold text-foreground mb-2 leading-snug">
            {b.title}
          </h3>
          <p className="text-base text-muted-foreground leading-relaxed mb-5">
            {b.description}
          </p>
          <div className="flex items-end justify-between gap-4">
            <span className="text-sm font-semibold text-primary">
              🎁 {b.bonus}
            </span>
            <span className="flex-shrink-0 inline-flex items-center gap-1.5 text-base font-semibold text-primary group-hover:underline">
              {b.cta}
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5" />
            </span>
          </div>
        </a>
      ))}
    </div>
  );
};

export default HeroBanners;
